import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AuthService, UserData } from "@app/core/features/auth";
import { BaseComponent } from "@app/shared/components/base/base/base.component";
import { environment } from '@env/index';
import { language as languageModel, DefaultLanguageCode, ListLanguageCode, RibbonType } from '@app/constants';
import { ActivatedRoute } from "@angular/router";
import { SelectedLanguageModel, ChartsStoreActions } from "@app/core/features/charts-store";
import { CookieService } from "ngx-cookie-service";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { State } from '@app/core/features';
import { getRandomNumber } from "@app/utils";
import { ChartsStoreService } from "@app/core/features/charts-store/charts-store.service";
import { LanguageService } from "@app/core/services/language/language.service";
import { MyChartsService } from "@app/core/features/charts-manager/my-charts/my-charts.service";

@Component({
   selector: 'app-checkout-header',
   templateUrl: './checkout.header.component.html',
   styleUrls: ['./checkout.header.component.scss']
})
export class CheckoutHeaderComponent extends BaseComponent implements OnInit, OnDestroy {
   @Input() loggedInUser: UserData;
   @Input() hasError: boolean;

   config = environment;
   ribbonClass: string;
   ribbonText: string;

   constructor(
      private route: ActivatedRoute,
      private authService: AuthService,
      private cookieService: CookieService,
      private translateService: TranslateService,
      private chartStoreService: ChartsStoreService,
      private languageService: LanguageService,
      private myChartsService: MyChartsService,
      protected store: Store<State>
   ) {
      super();
   }

   ngOnInit(): void {
      this.setHeaderRibbon();

      this.route.queryParams.subscribe(params => {
         if (params && params.lang && ListLanguageCode.includes(params.lang)) {
            this.translateLanguage(languageModel.find(row => row.code === params.lang));
         }
      });

      if (this.cookieService.get('lang')) {
         this.translateLanguage(languageModel.find(row => row.code === this.cookieService.get('lang')));
      } else if (this.checkLoginSuccess() && !this.cookieService.get('lang')) {
         const selectedLanguage = languageModel.find(row => row.code === this.loggedInUser.countryCode);

         this.translateLanguage(selectedLanguage);
         this.chartStoreService.saveLanguage({ language: selectedLanguage.code }).subscribe(() => {
            this.myChartsService.checkChangedLanguage.next(getRandomNumber());
         });
      } else {
         // Set default language is EU at the first time load the page
         this.translateLanguage(languageModel.find(row => row.code === DefaultLanguageCode));

         if (window.navigator && window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(
               position => {
                  this.languageService.getCountryCodeByCoordinate(position.coords.latitude, position.coords.longitude)
                     .subscribe(res => {
                        if (res && res !== DefaultLanguageCode) {
                           this.translateLanguage(languageModel.find(row => row.code === res));
                        }
                     });
               }
            );
         }
      }
   }

   private setHeaderRibbon() {
      this.ribbonClass = 'ribbon top-left ';
      this.ribbonText = RibbonType[this.config.ribbonType];

      switch (this.config.ribbonType) {
         case RibbonType.Local:
            this.ribbonClass += 'ribbon-success';
            break;
         case RibbonType.Dev:
            this.ribbonClass += 'ribbon-danger';
            break;
         case RibbonType.Stage:
            this.ribbonClass += 'ribbon-info';
            break;
         case RibbonType.Preprod:
            this.ribbonClass += 'ribbon-warning';
            break;

         default:
            this.ribbonClass = 'ribbon hidden';
            this.ribbonText = '';
            break;
      }
   }

   private translateLanguage(selectedLanguage: SelectedLanguageModel) {
      this.cookieService.set('lang', selectedLanguage.code, 365, '/');
      this.translateService.use(selectedLanguage.code);
      this.getJsonData(selectedLanguage.code);
   }

   private getJsonData(lang: string) {
      this.store.dispatch(new ChartsStoreActions({ lang }));
      this.chartStoreService.checkChangeLanguage.next(getRandomNumber());
      this.languageService.findMetaData();
   }

   private checkLoginSuccess = (): boolean => this.authService.checkoutAccount() && this.loggedInUser && !this.hasError;

   ngOnDestroy(): void {
      super.ngOnDestroy()
   }
}